interface Option<T extends string> {
  value: T;
  label: string;
}

export function Segmented<T extends string>({
  options,
  value,
  onChange,
}: {
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
}) {
  return (
    // Sig'masa (masalan admin'da 5 ta tab) — kesilmaydi, gorizontal aylantiriladi.
    <div
      className="flex gap-1 overflow-x-auto rounded-full border border-line bg-surface p-1 [scrollbar-width:none]"
      role="radiogroup"
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={o.value === value}
          onClick={(e) => {
            e.currentTarget.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            onChange(o.value);
          }}
          className={`flex-1 shrink-0 rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap transition-colors ${
            o.value === value ? 'bg-text text-bg' : 'text-muted'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
